import { render } from "./Gene_Protein.vue?vue&type=template&id=88ad00be"
import script from "./Gene_Protein.vue?vue&type=script&lang=js"
export * from "./Gene_Protein.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__